import { useEffect } from "react";
import mainProducts from "../mainProducts.json";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { addDefaultImg } from "../components/imageUtils";

const Products = () => {
  useEffect(() => {
    document.title = "Products - Deww Botanicals";
  }, []);

  const location = useLocation();
  const currentUrl = location.pathname;
  // Check if the URL contains a specific word
  const shouldShowElement = currentUrl.includes("products");

  return (
    <>
      {/* // Page Header Start */}
      {shouldShowElement && (
        <div
          className="container-fluid page-header"
          style={{ backgroundImage: `url(../assets/images/banner-1.jpg)` }}
        >
          <div className="container">
            <h1 className="display-5 mb-3 animated slideInDown">
              Our Products
            </h1>
            <nav aria-label="breadcrumb animated slideInDown">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a
                    className="text-body"
                    Using target="_blank" without rel="noreferrer"
                    href="javascript:void(0);"
                  >
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item text-dark active"
                  aria-current="page"
                >
                  Our Products
                </li>
              </ol>
            </nav>
          </div>
        </div>
      )}
      {/* // Page Header End */}
      <div className="container-fluid py-4 py-md-5 bg-theme-light">
        <div className="container">
          <div className="row g-0 gx-5 align-items-end">
            <div className="col-12">
              <div className="section-header mb-5 ">
                <h1 className="section-heading text-primary">
                  Discover the Ranges of..
                </h1>

                {shouldShowElement && (
                  <>
                    <h4 className="mt-4 text-primary">
                      Nature’s Finest, Crafted Just for You.
                    </h4>
                    <p>
                      Welcome to Deww Botanicals, where we bring you a world of
                      purity, potency, and plant-based excellence. Our extensive
                      selection of premium botanical ingredients is carefully
                      sourced and meticulously processed to cater to the diverse
                      needs of industries such as wellness, skincare, personal
                      care, and more.
                    </p>
                    <p>
                      From earth to essence, Deww Botanicals ensures
                      authenticity in every drop. Let nature enhance your
                      creations. Explore our complete range and experience the
                      purity of botanical excellence.
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="tab-content">
            <div className="tab-pane fade show p-0 active">
              {/* {shouldShowElement && ( */}
              <div className="row g-4">
                {mainProducts.map((oil, index) => {
                  return (
                    <div className="col-12 col-sm-6 " key={index}>
                      <Link to={oil.link}>
                        <div className="product-item homepage row bg-theme-primary m-0 rounded h-100">
                          <div className="position-relative bg-light overflow-hidden col-5 col-md-6 p-0">
                            <img
                              className="w-100"
                              src={oil.image}
                              onError={addDefaultImg}
                              alt={oil.name}
                            />
                            <div className="bg-success rounded text-white position-absolute start-0 top-0 m-2 py-1 px-3 nBadge">
                              New
                            </div>
                          </div>
                          <div className="text-left p-2 p-md-4 col-7 col-md-6 d-flex flex-column">
                            <p className="d-block text-theme-light h4 mb-2">
                              {oil.name}
                            </p>
                            <p className="text-theme-light description">
                              {oil.description}
                            </p>

                            <p
                              to={oil.link}
                              className="d-block text-light text-left h6 mb-1"
                            >
                              <i className="fa fa-eye text-light me-2"></i>
                              View List
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })}
                {!shouldShowElement && (
                  <div className="col-12 text-center ">
                    <a className="btn btn-primary py-3 px-5" href="/products">
                      Browse More Products
                    </a>
                  </div>
                )}
              </div>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
